// extracted by mini-css-extract-plugin
export default {"tabName":"CourseTab_tabName__rBOpx","underline":"CourseTab_underline__GvSMC","tabWrapper":"CourseTab_tabWrapper__0UZVI"};